import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
/**
 * This hook returns signupFormRestApi from Sitecore Context
 *
 * Sign up for update form submission in PE
 */
var useSignupFormRestApi = function () {
    var sitecoreContext = useSitecoreContext().sitecoreContext;
    return sitecoreContext.signupFormRestApi;
};
export default useSignupFormRestApi;
